module.exports = __webpack_public_path__ + "img/njm_g0-7.prt.78dde55d.jpg";